/**
 * Financial Chart
 *
 * @module
 */

import { $$ } from '../../utilities/QuerySelectors.js';
import { SelectButtons } from '../reusable/SelectButtons.js';

export class Chart {
    /**
     * @param {Element} container
     */
    constructor(container) {
        /** @type {HTMLElement} */ // @ts-ignore: Casting in docblocks is ugh.
        this.container = container;
        this.hasClass = s => container.classList.contains(s);
    }

    /**
     * Initialize the features for the financial charts.
     *
     * 1. Improve spacing on the left Y axis.
     * 2. Use buttons for changing to predefined time-scale range of the main chart.
     */
    init() {
        if (this.hasClass('main-chart')) {
            this.initMainChart();
        }
    }

    /**
     * Find the containers for the specified labels on all charts.
     *
     * @private
     * @param {string} axis 'x' or 'y'.
     * @param {string} side 'left' or 'right'.
     * @param {string} position 'inside' or 'outside'.
     * @return {Element[]}
     */
    getChartLabels(axis, side, position) {
        const pre = `.quoteapi-chart-${ axis }axis`;
        return $$(`${ pre }-${ side } ${ pre }-${ position } ${ pre }-label-container`, this.container);
    }

    initRangeButtons() {
        (new SelectButtons(
            document.querySelector('#main-chart-range-selector'),
            document.querySelector('#main-chart-range-buttons'),
            'range'
        )).init();
    }

    createSpaceForLeftYAxis() {
        /** @type {HTMLElement[]} */ // @ts-ignore: Casting in docblocks is ugh.
        const labels = this.getChartLabels('y', 'left', 'outside');
        const tryAgain = () => setTimeout(this.createSpaceForLeftYAxis.bind(this), 1000);
        if (labels.length === 0) {
            return tryAgain();
        }
        const yAxisWidth = Math.max.apply(this, labels.map(label => label.offsetWidth));
        if (yAxisWidth === 0) {
            return tryAgain();
        }
        this.container.style.paddingLeft = yAxisWidth + 'px';
    }

    initMainChart() {
        this.createSpaceForLeftYAxis();
        this.initRangeButtons();
    }
}
